

import { MeetingContainer, MeetingContainerAPI } from "@kalyzee/kast-web-sdk";
import { toastError } from "./toast";

type ContainerOrContainerApi = MeetingContainer | MeetingContainerAPI;

const getApi = (containerOrApi: ContainerOrContainerApi): MeetingContainerAPI => {
  if ("getAPI" in containerOrApi) {
    return containerOrApi.getAPI();
  }
  return containerOrApi;
};

const setMeetingSessionHeardByEveryoneState = async (
  containerOrApi: ContainerOrContainerApi,
  sessionId: string, 
  enabled: boolean,
) => {
  const api = getApi(containerOrApi);
  const result = await api.updater.update(sessionId, {
    canBeHeardByEveryone: enabled,
  });
  const { error, response } = result ?? {};
  if (!response || error) {
    toastError(`Vous n'avez pas pu ${enabled ? "activer" : "désactiver"} le broadcast`);
  }
};

export const ContainerUtils = {
  setMeetingSessionHeardByEveryoneState,
};